/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewPasswordCharacters
 */
export interface CRSFSecReviewPasswordCharacters {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewPasswordCharacters
     */
    lowercase: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewPasswordCharacters
     */
    numbers: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewPasswordCharacters
     */
    special: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewPasswordCharacters
     */
    uppercase: number;
}

/**
 * Check if a given object implements the CRSFSecReviewPasswordCharacters interface.
 */
export function instanceOfCRSFSecReviewPasswordCharacters(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lowercase" in value;
    isInstance = isInstance && "numbers" in value;
    isInstance = isInstance && "special" in value;
    isInstance = isInstance && "uppercase" in value;

    return isInstance;
}

export function CRSFSecReviewPasswordCharactersFromJSON(json: any): CRSFSecReviewPasswordCharacters {
    return CRSFSecReviewPasswordCharactersFromJSONTyped(json, false);
}

export function CRSFSecReviewPasswordCharactersFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewPasswordCharacters {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lowercase': json['lowercase'],
        'numbers': json['numbers'],
        'special': json['special'],
        'uppercase': json['uppercase'],
    };
}

export function CRSFSecReviewPasswordCharactersToJSON(value?: CRSFSecReviewPasswordCharacters | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lowercase': value.lowercase,
        'numbers': value.numbers,
        'special': value.special,
        'uppercase': value.uppercase,
    };
}

